<template>
  <el-dialog
    :visible="visible"
    title="提示"
    width="600"
    @open="open"
    @close="close"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <template #title><i class="el-icon-s-go text-success"></i>认购</template>

    <el-row
      :gutter="16"
      v-for="item in formData.buys"
      :key="item.defiCoinType"
      style="display: flex; align-items: center"
    >
      <el-col :span="4" class="flex align-center">
        <div class="flex align-center" style="height: 100%; font-weight: 700">
          {{ item.defiCoinType }}
        </div>
      </el-col>
      <el-col :span="10">
        <div class="flex align-center" style="height: 100%">
          增加认购数量：
          <el-input
            type="number"
            v-model="item.buyFinancing"
            class="width-100"
            size="small"
          ></el-input>
        </div>
      </el-col>
    </el-row>

    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" @click="close">取 消</el-button>
        <el-button size="mini" type="primary" @click="okBtnClick"
          >确 定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  inheritAttrs: false,
  components: {},
  props: ['visible', 'currentId'],
  data() {
    return {
      isCanSave: true,
      formData: {
        buys: [],
        scale: 0,
      },
    }
  },
  computed: {
    ...mapState('financial', ['coinList']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    ...mapActions('financial', ['getStakingDetail', 'setStakingBuy']),
    open() {
      this.formData.id = this.currentId
      this.getStakingDetail({ id: this.currentId }).then(({ data }) => {
        this.formData.scale = data.scale
        this.formData.buys = data.dtos.map((item) => ({
          defiCoinType: item.defiCoinType, //质押币种
          defiId: item.defiId, //质押币种Id
          totalFinancing: parseFloat(item.totalFinancing), //质押币种申购限额
          nowFinancing: parseFloat(item.nowFinancing), //用户质押
          allFinancing: parseFloat(item.allFinancing), //总质押
          sliderPeriod: [
            parseFloat(item.nowFinancing),
            parseFloat(item.allFinancing),
          ],
          buyFinancing: 0, //初始进入新增为0
        }))
      })
    },
    close() {
      // this.$refs['formRef'].resetFields()

      this.$emit('update:visible', false)
    },
    okBtnClick() {
      const param = {
        buys: this.formData.buys.map((item) => ({
          buyFinancing: item.buyFinancing,
          defiId: item.defiId,
        })),
        id: this.currentId,
      }
      this.setStakingBuy(param)
    },
    countChange() {},
  },
}
</script>
